<template>
    <a
        class="brand-filter-item"
        :href="link"
    >
        <div class="item-content">
            <el-image
                v-if="hasLogo"
                :src="logo"
                class="brand-image"
                fit="contain"
                :alt="title"
            ></el-image>
            <div
                v-else
                class="brand-no-image"
            >{{ title }}
            </div>
        </div>
        <div v-if="hasUnreadMessages" class="unread-stats">
            <span class="badge badge-danger badge-smaller badge-pill">{{ unreadMessages }}</span>
        </div>
    </a>
</template>

<script>
  import {addQueryParams} from "../../../libs/url";
  import eventBus from "../../../event-bus";

  export default {
    props: {
      value: Object,
      baseUrl: null,
      stats: null,
    },

    data() {
      return {
        link: '',
      };
    },

    computed: {
      /**
       * @return {String|null}
       */
      logo() {
        return _.get(this.value, 'model.logo', null);
      },

      /**
       * @return {String|null}
       */
      title() {
        return _.get(this.value, 'model.title', null);
      },

      /**
       * @return {Boolean}
       */
      hasLogo() {
        return !_.isEmpty(this.logo);
      },

      /**
       * @return {Number|null}
       */
      id() {
        return _.get(this.value, 'model.id', null);
      },

      /**
       * @return {number|null}
       */
      unreadMessages() {
        return _.get(this.stats, 'count', null);
      },

      /**
       * @return {boolean}
       */
      hasUnreadMessages() {
        return Boolean(this.unreadMessages);
      },
    },

    watch: {
      baseUrl() {
        this.updateLink();
      },
    },

    methods: {
      updateLink() {
        const additional = this.id ? {brand_id: String(this.id)} : {};
        this.link = addQueryParams(this.baseUrl || '', additional);
      },

      /**
       * @param {Number} brandId
       */
      incrementCounter(brandId) {
        if (this.id === brandId) {
          _.isNull(this.stats) ?
              this.stats = {count: 1} :
              this.stats.count++;
        }
      },
    },

    created() {
      eventBus.$on('on-increment-brand-counter', this.incrementCounter);
    },

    beforeDestroy() {
      eventBus.$off('on-increment-brand-counter', this.incrementCounter);
    },
  }
</script>
